import GalleryTemplate from 'components/modelManager/templates/GalleryTemplate'
import ModelDetailTemplate from 'components/modelManager/templates/ModelDetailTemplate'
import { ResourceKey, resources } from 'config/resources'
import Configuration from 'configuration/Configuration'
import { useAuthProvider } from 'context/auth/AuthProvider'
import { lightTheme } from 'layout/theme/LightTheme'
import { Admin, CustomRoutes, DataProvider, I18nProvider, Resource } from 'react-admin'
import { Route } from 'react-router'
import AuthProvider from './AuthProvider'
import Dashboard from './dashboard/dashboard'
import Layout from './layout/Layout'
import Login from './layout/Login'
import ModelList from './resources/models/ModelList'

const customRoutes = [
    { path: '/configuration', element: <Configuration /> },
    { path: '/gallery', element: <GalleryTemplate /> },
    { path: '/models', element: <ModelList /> },
    { path: '/model/:code', element: <ModelDetailTemplate /> }
]

export const AdminContent = ({
    dataProvider,
    i18nProvider
}: {
    dataProvider: DataProvider
    i18nProvider: I18nProvider
}) => {
    const { permissions } = useAuthProvider()

    return (
        <Admin
            theme={lightTheme}
            dataProvider={dataProvider}
            authProvider={AuthProvider}
            i18nProvider={i18nProvider}
            dashboard={Dashboard}
            layout={Layout}
            loginPage={Login}
            requireAuth
        >
            <>
                {permissions &&
                    (Object.keys(resources) as ResourceKey[]).map((key) =>
                        permissions[key]?.length > 0 ? (
                            <Resource key={key} name={key} {...resources[key]} />
                        ) : null
                    )}
            </>

            <CustomRoutes>
                {customRoutes.map(({ path, element: Element }) => (
                    <Route key={path} path={path} element={<>{Element}</>} />
                ))}
            </CustomRoutes>
        </Admin>
    )
}
